import React, { useContext } from "react"
import { Spinner } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { 
    faUser,
    faNewspaper,
    faCalendarAlt,
} 
from '@fortawesome/free-solid-svg-icons'
import { LanguageContext } from '../Language/LanguageContext'
import { convertToSimply } from '../Library'

export default function StatSection(props){
    const langCx = useContext(LanguageContext)
    const lang = langCx.lang.home
    const isLoading = props.isLoading || false
    const newsCount = props.newsCount || 0
    const userCount = props.userCount || 0
    const eventCount = props.eventCount || 0

    return(
        <div className="section">
            { isLoading ?
            <div className="loading-section">
                <Spinner 
                variant="primary" 
                animation="border"
                size="sm"
                />
            </div> : null
            }
            <div className="stat-container">
                <div className="item item-flex">
                    <div className="number">{convertToSimply(newsCount)}</div>
                    <div className="title">
                        <FontAwesomeIcon icon={faNewspaper} style={{marginRight: 5}}/>
                        {lang.news}
                    </div>
                </div>
                <div className="item item-flex">
                    <div className="number">{convertToSimply(eventCount)}</div>
                    <div className="title">
                        <FontAwesomeIcon icon={faCalendarAlt} style={{marginRight: 5}}/>
                        {lang.next_event}
                    </div>
                </div>
                <div className="item item-flex">
                    <div className="number">{convertToSimply(userCount)}</div>
                    <div className="title">
                        <FontAwesomeIcon icon={faUser} style={{marginRight: 5}}/>
                        {lang.all_user}
                    </div>
                </div>
                
            </div>
        </div>
    )
}
